import { useId } from 'react';
import { Container, Section } from './atomic';

/**
 * Contact section component that serves as the footer with contact information and collaboration call-to-action.
 *
 * This component displays:
 * - RSM Collective logo and branding
 * - Collaboration invitation message
 * - Direct contact email for inquiries
 * - Copyright and legal information
 * - Scroll anchor for navigation
 *
 * The component encourages visitors to join The Collective as consultants,
 * service integrators, or to collaborate on modernization projects.
 *
 * @returns {JSX.Element} Contact section with collaboration invitation and contact details
 */
function ContactSection() {
  const contactId = useId();

  return (
    <Section component="footer" dark>
      {/* Scroll anchor spacer for #contact */}
      <div
        id={contactId}
        style={{ height: '100px', marginTop: '-100px' }}
      ></div>

      <Container>
        {/* Empty container - section kept for spacing/structure */}
      </Container>
    </Section>
  );
}

export default ContactSection;
